<template>
  <dialog
    ref="dialogEl"
    class="scrim"
    aria-labelledby="friend-invite-title"
    @cancel.prevent="emit('decline')"
    @click="onScrimClick"
  >
    <div class="panel">
      <h2 id="friend-invite-title">{{ t('friends.inviteIncoming', { name: username }) }}</h2>
      <div class="actions">
        <button type="button" class="md-btn-tonal" @click="emit('accept')">
          {{ t('friends.inviteAccept') }}
        </button>
        <button type="button" class="text-btn" @click="emit('decline')">
          {{ t('friends.inviteDecline') }}
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from '../i18n/t'

defineProps<{
  username: string
  code: string
}>()

const emit = defineEmits<{
  accept: []
  decline: []
}>()

const { t } = useI18n()
const dialogEl = ref<HTMLDialogElement | null>(null)

function onScrimClick(event: MouseEvent): void {
  if (event.target === dialogEl.value) emit('decline')
}

onMounted(() => {
  dialogEl.value?.showModal()
})
</script>

<style scoped>
.scrim {
  padding: 0;
  border: 0;
  background: transparent;
  max-width: calc(100vw - 32px);
}

.scrim::backdrop {
  background: var(--md-scrim);
}

.panel {
  width: min(420px, calc(100vw - 32px));
  padding: 24px;
  border-radius: 28px;
  background: var(--md-sys-color-surface-container);
  color: var(--md-sys-color-on-surface);
  box-shadow: var(--md-elevation-2);
}

h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.3;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.md-btn-tonal,
.text-btn {
  min-height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 20px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.md-btn-tonal {
  background: var(--md-sys-color-primary);
  color: var(--md-sys-color-on-primary);
}

.text-btn {
  background: transparent;
  color: var(--md-sys-color-primary);
}
</style>
